import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=387c8fc4&"
import script from "./Car.vue?vue&type=script&lang=js&"
export * from "./Car.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports